export default __webpack_public_path__ + "static/media/galaryPlaceholder.e085d6a5.svg";